import { render, staticRenderFns } from "./amend.vue?vue&type=template&id=6f6ecfea&scoped=true&"
import script from "./amend.vue?vue&type=script&lang=js&"
export * from "./amend.vue?vue&type=script&lang=js&"
import style0 from "./amend.vue?vue&type=style&index=0&id=6f6ecfea&lang=scss&scoped=true&"
import style1 from "./amend.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6ecfea",
  null
  
)

export default component.exports